<template>
  <div>
    <div class="header-gnb">
      <h1 class="logo">
        <a href="#" @click.prevent="changeUrl({path: '/index.html', name: 'home'})">
          <img src="../../../assets/images/common/ci-wavve.svg" alt="Wavve">
        </a>
      </h1>

      <nav id="menu" class="gnb-left">
        <ul>
          <li>
            <a href="#" :class="isActive(['home'])" @click.prevent="changeUrl({path: '/index.html', name: 'home'})">홈</a>
          </li>
          <li class="category-list-item" @focusin="focus()" @mouseenter="focus()" @mouseleave="blur()" ref="gnbCategory"
              :key="'CATEGORY_INDEX_KEY_' + categoryKeyIndex">
            <button type="button" tabindex="0" data-gnb="category-menu">카테고리</button>
            <category-menu></category-menu>
            <category-menu-layer></category-menu-layer>
          </li>
          <li>
            <a href="#" :class="isActive(['live'])" @click.prevent="changeUrl({path: '/live/index.html', name: 'live'})">LIVE</a>
          </li>
          <li>
            <a href="#" :class="isActive(['my'])" @click.prevent="changeUrl({path: '/my', name: 'my'})">MY</a>
          </li>
        </ul>
      </nav>
      <div :class="[
        'search-box',
        {'active' : isSearchBoxOpen},
        {'result': isSearchBoxAlwaysOpen}]">
        <label for="search" type="button" class="btn-search" tabindex="0">
          <span class="a11y-hidden">검색</span>
        </label>
        <input
          type="text"
          @input="inputHandler($event)"
          @focus.self.prevent="goSearchRouter"
          @keydown.enter="enterSearchData()"
          :value="keyword"
          class="search-inpt"
          id="search"
          name="search"
          placeholder="제목, 장르, 배우로 찾아보세요"
          ref="searchInput"
        >
        <button
          type="button"
          class="btn-del"
          @click.prevent="deleteSearchData()"
        >
          <span class="a11y-hidden">검색어 삭제</span>
        </button>
      </div>
    </div>
    <SearchPopup
      v-if="showSearchPop"
      id="searchPop"
      :closeSearchPopup="closeSearchPopup"
      :search-page-type="searchPageType"
    />
  </div>
</template>

<script>
import _, { get } from 'lodash'
import { stringify } from 'query-string'
import SearchPopup from '@/components/search/view/SearchPopup'
import { removePrefixEmptyString, setDisableScrolling, setSearchWordSave } from '@/common/utils/common'
import { UPDATE_MAIN_LAYOUT_CONTENT, SET_CURRENT_MENU, SEARCH_INPUT_FOCUS, SEARCH_TYPING_QUERY, SEARCH_RESULT_QUERY, SEARCH_AGAIN_INPUT_FOCUS, SEARCH_HEADER_TAG_LAYER, SEARCH_SAME_QUERY } from '@/common/resources/const'
import { mapMutations, mapGetters } from 'vuex'
import CategoryMenu from '@/components/common/header/CategoryMenu'
import CategoryMenuLayer from '@/components/common/header/CategoryMenuLayer'
import {
  categoryInfo,
  EVENT_UPDATE_CATEGORY_COMPONENT
} from '@/common/utils/gnb.category'
import { PATH_NAME_SEARCH } from '@/common/resources/router.const'
import {
  sendEventLogTextSearch,
  sendEventLogExitToGnb,
  sendEventLogCloseTagSearchPopup, sendEventLogDeleteSearchKeyword, sendEventLogSearchOpen
} from '@/common/utils/log.v2.send'
import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'

const MESSAGE_SEARCH_WORD_LENGTH_LIMIT = `최대 50자까지 입력 가능합니다. 글자수를 확인해주세요.`
const MESSAGE_SEARCH_WORD_IS_EMPTY = `검색어를 입력 하세요.`

export default {
  components: { CategoryMenuLayer, CategoryMenu, SearchPopup },
  data () {
    return {
      showSearchPop: false,
      searchPageType: 'broadcast',
      section: '',
      categoryKeyIndex: 0,
      isSearchBoxOpen: false,
      isSearchBoxAlwaysOpen: false,
      query: this.$route.query?.searchWord ?? '',
      keyword: ''
    }
  },
  computed: {
    ...mapGetters(['currentMenu'])
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
    this.$events.$on(SEARCH_INPUT_FOCUS, () => {
      this.$refs.searchInput.focus()
    })
    this.checkQuery()
  },
  created () {
    this.$events.$on('showSearchPopupTag', value => {
      this.showSearchPopup(value)
    })
    this.$events.$on(EVENT_UPDATE_CATEGORY_COMPONENT, this.categoryComponentUpdate)
    this.$events.$emit(SEARCH_HEADER_TAG_LAYER, { isTagLayerOpen: false })
    this.checkKeywordReplace()
    window.showTagSearchLayout = (type) => {
      let tempType = type
      if (type === 'movie') tempType = 'reTagDetail_movie'
      this.showSearchPopup(tempType)
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    changeUrl (gnbInfo) {
      const { path, name } = gnbInfo
      if (this.$route.name === name) {
        this.$events.$emit(UPDATE_MAIN_LAYOUT_CONTENT)
      } else {
        if (LOG_SEND_LIST.includes(this.$route.name)) sendEventLogExitToGnb({ name: name, route: this.$route, landingUrl: path })
        this.$router.push(path)
      }
    },
    isActive (type) {
      return type.indexOf(this.currentMenu) > -1 ? 'on' : ''
    },
    setSection () {
      const section = _.get(this.$route, ['meta', 'section'], '')
      if (section) {
        this.section = section
      }
    },
    showSearchPopup (type) {
      if (typeof window.setInputShow === 'function') {
        window.setInputShow(false)
      }
      this.searchPageType = type
      this.showSearchPop = true
      this.$events.$emit(SEARCH_HEADER_TAG_LAYER, { isTagLayerOpen: true })
      setDisableScrolling(true) // 윈도우 스크롤 방지
      if (window.playerInstance) window.playerInstance.clearEvent() // 플레이어 키 이벤트 비활성화
    },
    closeSearchPopup () {
      this.showSearchPop = false
      sendEventLogCloseTagSearchPopup({ type: this.searchPageType })
      this.$events.$emit(SEARCH_HEADER_TAG_LAYER, { isTagLayerOpen: false })
      setDisableScrolling(false) // 윈도우 스크롤 사용
      if (window.playerInstance) window.playerInstance.setupEvent() // 플레이어 키 이벤트 활성화
    },
    categoryComponentUpdate () {
      categoryInfo.clearCache()
      this.categoryKeyIndex += 1
    },
    focus () {
      this.$refs.gnbCategory.classList.add('on')
    },
    blur () {
      this.$refs.gnbCategory.classList.remove('on')
    },
    keyup (e) {
      if (e.target.dataset.gnb !== 'category-menu') this.blur()
    },
    goSearchRouter () {
      const CURRENT_URL_NAME = _.get(this.$route, 'name', '')
      const IS_DIFFERENT_ROUTE_LOCATION = (CURRENT_URL_NAME !== PATH_NAME_SEARCH)
      this.$events.$emit(SEARCH_AGAIN_INPUT_FOCUS, { isAutoCompleteReady: true })
        this.isSearchBoxOpen = true
      if (IS_DIFFERENT_ROUTE_LOCATION) {
        sendEventLogSearchOpen({ route: this.$route })
        this.$router.push({
          name: PATH_NAME_SEARCH
        })
      }
    },
    checkInputValidation () {
      const MAX_SEARCH_LENGTH = 50
      if (this.keyword.length > MAX_SEARCH_LENGTH) {
        alert(MESSAGE_SEARCH_WORD_LENGTH_LIMIT)
        this.keyword = this.keyword.slice(0, MAX_SEARCH_LENGTH)
      }
    },
    getAutoCompleteData: _.debounce(function (event) { this.sendAutoCompleteData(event) }, 400),
    sendAutoCompleteData (event) {
      this.$events.$emit(SEARCH_TYPING_QUERY, event.target.value)
    },
    inputHandler (event) {
      this.keyword = removePrefixEmptyString(event.target.value)

      this.checkInputValidation()
      this.getAutoCompleteData(event)
    },
    deleteSearchData () {
      const KEYWORD_INITIALIZED = ''
      sendEventLogDeleteSearchKeyword()
      this.$events.$emit(SEARCH_TYPING_QUERY, KEYWORD_INITIALIZED)
      this.$events.$emit(SEARCH_RESULT_QUERY, KEYWORD_INITIALIZED)
      this.$refs.searchInput.value = KEYWORD_INITIALIZED
      this.isSearchBoxAlwaysOpen = true
    },
    enterSearchData () {
      if (this.keyword.length === 0) { alert(MESSAGE_SEARCH_WORD_IS_EMPTY); return false }
      setSearchWordSave(this.keyword)
      if (this.query !== this.keyword) {
        this.$events.$emit(SEARCH_RESULT_QUERY, this.keyword)
        this.$events.$emit(SEARCH_TYPING_QUERY, '')
        sendEventLogTextSearch({ keyword: this.keyword, landingUrl: `${PATH_NAME_SEARCH}?${stringify({ searchWord: this.keyword })}` })
        this.$router.push({
          name: PATH_NAME_SEARCH,
          query: { searchWord: this.keyword }
        })
      } else {
        this.$events.$emit(SEARCH_SAME_QUERY)
      }
    },
    checkQuery () {
      if (this.query) {
        this.isSearchBoxAlwaysOpen = true
        this.keyword = this.query
        this.$events.$emit(SEARCH_RESULT_QUERY, this.query)
      }
    },
    checkKeywordReplace () {
      const HAS_QUERY_KEYWORD = get(this.$route, 'query.keyword', '') !== ''
      if (HAS_QUERY_KEYWORD) {
        this.$router.replace({
          name: PATH_NAME_SEARCH,
          query: { searchWord: removePrefixEmptyString(get(this.$route, 'query.keyword', '')) }
        })
      }
    }
  },
  beforeDestroy () {
    delete window.showTagSearchLayout
    this.$events.$off('showSearchPopup')
    this.$events.$off('setInputShow')
    this.$events.$off(EVENT_UPDATE_CATEGORY_COMPONENT)
    this.$events.$off(SEARCH_INPUT_FOCUS)
    document.removeEventListener('keyup', this.keyup)
  },
  watch: {
    $route () {
      this.setSection()
    }
  }
}
</script>
